var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandLess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1317_31468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1317_31468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 14.95C11.8668 14.95 11.7418 14.9292 11.6252 14.8875C11.5085 14.8458 11.4002 14.775 11.3002 14.675L6.67515 10.05C6.49182 9.86667 6.40432 9.63751 6.41265 9.36251C6.42099 9.08751 6.51682 8.85834 6.70015 8.67501C6.88349 8.49167 7.11682 8.40001 7.40015 8.40001C7.68349 8.40001 7.91682 8.49167 8.10015 8.67501L12.0002 12.575L15.9252 8.65001C16.1085 8.46667 16.3377 8.37917 16.6127 8.38751C16.8877 8.39584 17.1168 8.49167 17.3002 8.67501C17.4835 8.85834 17.5752 9.09167 17.5752 9.37501C17.5752 9.65834 17.4835 9.89167 17.3002 10.075L12.7002 14.675C12.6002 14.775 12.4918 14.8458 12.3752 14.8875C12.2585 14.9292 12.1335 14.95 12.0002 14.95Z",
    fill: "black",
    fillOpacity: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandLess);
export default __webpack_public_path__ + "static/media/expand_less.9a9951ca30cf1ce79837c48b82cff77d.svg";
export { ForwardRef as ReactComponent };